import * as React from "react";
import { Modal, Button, Loader } from "semantic-ui-react";

import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { goToParent } from "@teamprevent/common/routing";

import { Input } from "@neworbit/simpleui-input";

import { IsLoadingButton } from "@teamprevent/common/IsLoadingButton";

import { GenericCaseType } from "../../../genericCaseTypes/models";
import { GenericCaseTypeApi } from "../../../genericCaseTypes/GenericCaseTypeApi";
import { CREATE_GENERIC_CASE } from "../../../genericCases/actionTypes";
import { createGenericCase } from "../../../genericCases/actions";
import { routeIdSelector as customerIdSelector } from "../../customer/selectors";
import { routeIdSelector as employeeRecordIdSelector } from "../../employeeRecord/selectors";

import { push } from "redux-little-router";

const CreateGenericCaseModal: React.FunctionComponent = () => {
    const [genericCaseTypes, setGenericCaseTypes] = React.useState<GenericCaseType[]>();
    const [selectedGenericCaseTypeId, setSelectedGenericCaseTypeId] = React.useState<string>();
    const [loading, setLoading] = React.useState(false);
    const [submitted, setSubmitted] = React.useState(false);
    const customerId = useSelector(customerIdSelector);
    const employeeRecordId = useSelector(employeeRecordIdSelector);

    const dispatch = useDispatch();

    const onClose = React.useCallback(() => dispatch(goToParent()), [dispatch]);
    const onCreate = React.useCallback(async () => {
        setSubmitted(true);
        if (!selectedGenericCaseTypeId) {
            return;
        }
        const newOhCase = await dispatch(createGenericCase(customerId, employeeRecordId, selectedGenericCaseTypeId));
        dispatch(push(`/customers/${customerId}/employeeRecords/${employeeRecordId}/ohCases/${newOhCase.id}/firstTask`));
    }, [customerId, dispatch, employeeRecordId, selectedGenericCaseTypeId]);

    React.useEffect(() => {
        (async () => {
            setLoading(true);
            setGenericCaseTypes((await GenericCaseTypeApi.getAll()).filter(t => t.active));
            setLoading(false);
        })();
    }, []);

    return (
        <Modal open>
            <Modal.Header>Create Generic Case</Modal.Header>
            <Modal.Content>
                {loading && <Loader />}
                {genericCaseTypes &&
                    <Input.Dropdown
                        options={genericCaseTypes.map(t => ({ text: t.name, value: t.id }))}
                        required
                        showErrors={submitted}
                        value={selectedGenericCaseTypeId}
                        onChange={setSelectedGenericCaseTypeId}
                    />}
            </Modal.Content>
            <Modal.Actions>
                <Button content="Cancel" onClick={onClose} />
                <IsLoadingButton content="Create" onClick={onCreate} requestNames={CREATE_GENERIC_CASE} />
            </Modal.Actions>
        </Modal>
    );
};

export { CreateGenericCaseModal };
